"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('toggleExpansion')(legacy_1.select({
    store: function () { return store_1.default; },
})(function toggleExpansion(state) {
    state.store.isExpansionOpen = !state.store.isExpansionOpen;
}));
//# sourceMappingURL=toggleExpansion.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/actions/toggleExpansion.js
// module id = 4828
// module chunks = 48